import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
export function updatePathway(ajaxResponse) {
    var xhr = ajaxResponse.xhr;
    var responseXML = xhr.responseXML;
    // TODO is there a better way to handle namespaces in browser?
    var messageNode = responseXML.querySelector('success') || responseXML.querySelector('ns1\\:success') ||
        responseXML.querySelector('failure') || responseXML.querySelector('ns1\\:failure');
    return Observable.of({
        status: xhr.status,
        statusText: xhr.statusText,
        message: messageNode.textContent,
    });
}
;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiWE1MUmVzcG9uc2VQYXJzZXJzLmJyb3dzZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzcmMvWE1MUmVzcG9uc2VQYXJzZXJzLmJyb3dzZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFVBQVUsRUFBRSxNQUFNLGlCQUFpQixDQUFDO0FBRTdDLE9BQU8sd0JBQXdCLENBQUM7QUFFaEMsTUFBTSx3QkFBd0IsWUFBMEI7SUFLdkQsSUFBTSxHQUFHLEdBQUcsWUFBWSxDQUFDLEdBQUcsQ0FBQztJQUM3QixJQUFNLFdBQVcsR0FBRyxHQUFHLENBQUMsV0FBVyxDQUFDO0lBRXBDLDhEQUE4RDtJQUM5RCxJQUFNLFdBQVcsR0FBRyxXQUFXLENBQUMsYUFBYSxDQUFDLFNBQVMsQ0FBQyxJQUFJLFdBQVcsQ0FBQyxhQUFhLENBQUMsZUFBZSxDQUFDO1FBQ3JHLFdBQVcsQ0FBQyxhQUFhLENBQUMsU0FBUyxDQUFDLElBQUksV0FBVyxDQUFDLGFBQWEsQ0FBQyxlQUFlLENBQUMsQ0FBQztJQUNwRixPQUFPLFVBQVUsQ0FBQyxFQUFFLENBQUM7UUFDcEIsTUFBTSxFQUFFLEdBQUcsQ0FBQyxNQUFNO1FBQ2xCLFVBQVUsRUFBRSxHQUFHLENBQUMsVUFBVTtRQUMxQixPQUFPLEVBQUUsV0FBVyxDQUFDLFdBQVc7S0FDaEMsQ0FBQyxDQUFDO0FBQ0osQ0FBQztBQUFBLENBQUMifQ==


//////////////////
// WEBPACK FOOTER
// ./src/XMLResponseParsers.browser.ts
// module id = 61
// module chunks = 0